import {
    GetList,
    PostLocationBuyer,
    GetLocationBuyer,
    PutLocationBuyer,
    ChangeLocationBuyerStatus,
} from '@src/services/location-buyers'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    listLocationBuyer: [],
}

export const getters = {
    totalList(state) {
        return state.listLocationBuyer.data ?
            state.listLocationBuyer.data.totalItemCount :
            0
    },
}

export const mutations = {
    FETCH_LOCALS(state, locals) {
        state.listLocationBuyer = locals
    },
    SET_STATE(state, payload) {
        if (state.listLocationBuyer.data) {
            state.listLocationBuyer.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    SET_STATE_FORM(state, payload) {
        state.locationBuyerFormState = payload
    },
    UPDATE_PLAN(state, payload) {
        state.locationBuyerFormState = payload
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listLocationBuyer.data.items.push(team)
        })
    },
}

export const actions = {
    async fetchLocationBuyerList({ commit }, parameters = {}) {
        const resp = await GetList(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
    },
    async getLocationBuyer({ _ }, parameters) {
        const resp = await GetLocationBuyer(parameters)
        if (resp && resp.status === 200) {
            return resp.data.data
        }
    },
    async createBuyer({ _ }, parameters) {
        const resp = await PostLocationBuyer(parameters)
        return resp
    },
    async updateBuyer({ _ }, parameters) {
        const resp = await PutLocationBuyer(parameters)
        return resp
    },
    async changeBuyerStatus({ commit, dispatch }, data) {
        const resp = await ChangeLocationBuyerStatus(data)
        if (resp.status === 200) {
            if (!data.form) {
                dispatch('fetchList')
                commit('SET_STATE', data)
            }
            return true
        }
        return false
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}